import { gql } from '@apollo/client';

// Fragments
export const NOTIFICATION_FRAGMENT = gql`
  fragment NotificationFields on AppNotification {
    id
    userId
    type
    title
    body
    data
    isRead
    createdAt
    readAt
  }
`;

// Queries
export const LIST_MY_NOTIFICATIONS = gql`
  ${NOTIFICATION_FRAGMENT}
  query ListMyNotifications($limit: Int, $nextToken: String) {
    listMyNotifications(limit: $limit, nextToken: $nextToken) {
      items {
        ...NotificationFields
      }
      nextToken
      unreadCount
    }
  }
`;

export const GET_UNREAD_NOTIFICATION_COUNT = gql`
  query GetUnreadNotificationCount {
    getUnreadNotificationCount
  }
`;

// Mutations
export const MARK_NOTIFICATION_AS_READ = gql`
  ${NOTIFICATION_FRAGMENT}
  mutation MarkNotificationAsRead($id: ID!) {
    markNotificationAsRead(id: $id) {
      ...NotificationFields
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsAsRead
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotification($id: ID!) {
    deleteNotification(id: $id)
  }
`;

export const CLEAR_ALL_NOTIFICATIONS = gql`
  mutation ClearAllNotifications {
    clearAllNotifications
  }
`;

// Subscription for real-time notifications
export const ON_NOTIFICATION_RECEIVED = gql`
  ${NOTIFICATION_FRAGMENT}
  subscription OnNotificationReceived($userId: ID!) {
    onNotificationReceived(userId: $userId) {
      ...NotificationFields
    }
  }
`;

// Types
export type NotificationType = 
  | 'MESSAGE' 
  | 'ASSIGNMENT' 
  | 'CLIENT_ASSIGNMENT' 
  | 'APPOINTMENT' 
  | 'BULLETIN_POST' 
  | 'CLIENT_REMINDER' 
  | 'TASK'
  | 'VIDEO_CONFERENCE';

export interface AppNotification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string;
  data?: Record<string, any>;
  isRead: boolean;
  createdAt: string;
  readAt?: string;
}

export interface ListMyNotificationsResponse {
  listMyNotifications: {
    items: AppNotification[];
    nextToken?: string;
    unreadCount: number;
  };
}
